<script>console.log("FRM APP")</script>
<app-global-nav />
<app-secondary-nav />
<main class="frm-content">
  <router-outlet />
</main>
<app-footer />

<div *ngIf="idleWarningVisible()" class="idle-timeout-backdrop" role="presentation" (click)="continueSession()">
  <section
    class="idle-timeout-dialog"
    (click)="$event.stopPropagation()"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="idle-timeout-title"
    aria-describedby="idle-timeout-description">
    <h2 id="idle-timeout-title">Session Timeout Warning</h2>
    <p id="idle-timeout-description">
      You have been idle for 15 minutes. You will be logged out in
      <strong>{{ countdownText() }}</strong>.
    </p>
    <div class="idle-timeout-actions">
      <button type="button" class="idle-timeout-btn idle-timeout-btn-secondary" (click)="continueSession()">
        Stay Signed In
      </button>
      <button type="button" class="idle-timeout-btn idle-timeout-btn-primary" (click)="logoutNow()">
        Logout Now
      </button>
    </div>
  </section>
</div>
